import type { DocumentDownloadFormat, DocumentDownloadTarget } from '@/js/account/entities/document/model/types';
import { ref, type Ref } from 'vue';
import {
  downloadDocument,
  hasDocumentDownloads,
} from '@/js/account/entities/document/model/document-actions';

export function useDocumentDownload(): {
  downloadingId: Ref<number | null>
  onDocumentDownload: (
  document: DocumentDownloadTarget,
  format: DocumentDownloadFormat,
  ) => Promise<void>
} {
  const downloadingId = ref<number | null>(null);

  async function onDocumentDownload(
    document: DocumentDownloadTarget,
    format: DocumentDownloadFormat,
  ): Promise<void> {
    if (
      downloadingId.value !== null
      || !hasDocumentDownloads(document)
    ) {
      return;
    }

    downloadingId.value = document.id;

    try {
      await downloadDocument(document, format);
    }
    finally {
      downloadingId.value = null;
    }
  }

  return { downloadingId, onDocumentDownload };
}
